/**
 * RedirectPlatformToControlTower
 *
 * Wraps a route element. If the current user is a platform_owner /
 * platform_admin, replaces the original page with a redirect to
 * `/platform` — the Control Tower.
 *
 * Use case: keep `/dashboard`, `/plans`, `/billing` routes alive for tenants
 * (they still need them) but redirect platform users away from commercial UX.
 *
 * Architectural boundary:
 *   - Platform Owner → /platform (SaaS operations)
 *   - Tenant Owner   → original route (commercial features)
 */
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";


export default function RedirectPlatformToControlTower({ children }) {
  const { isPlatform, checking } = useAuth();
  // Wait for auth bootstrap — avoid mounting the original page just to
  // unmount it on the next tick.
  if (checking) return null;
  if (isPlatform) {
    return <Navigate to="/platform" replace />;
  }
  return children;
}
